var exports = {
  "kL": "container__wAO55x",
  "wx": "header__yRcIq7",
  "sW": "bordered__bHQ6xH",
  "Qs": "content__Ib2MkV",
};

module.exports = exports;
